import { render, staticRenderFns } from "./productForm.vue?vue&type=template&id=45ef6890&scoped=true&"
import script from "./productForm.vue?vue&type=script&lang=babel&"
export * from "./productForm.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ef6890",
  null
  
)

export default component.exports